<template>
  <v-dialog :value="show_dialog" width="900" persistent>
    <v-card>
      <v-card-title class="text-h5" :style="stylef['button']">Success</v-card-title>
      <div>
        <v-card-text>
          <div class="mb-2">
            An email with an activation link for your report has been sent to your email
            address.
          </div>
          <div class="mb-2">
            Once you receive the email click on the activation link and your report will
            be generated and delivered to your inbox.
          </div>
          <div class="mb-2">
            A maximum of {{ maximum_reports || 3 }} reports can be generated using this
            facility.
          </div>

          <div class="mb-2">
            Additional assistance can be requested from
            {{ brand_display_name || 'the institution' }}.
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="flex-wrap">
          <v-spacer></v-spacer>
          <v-btn
            v-if="appointment_booking_url"
            :style="stylef['button']"
            :href="appointment_booking_url"
            target="_blank"
            rel="noopener noreferrer"
            text
          >
            <v-icon left>mdi-calendar-clock</v-icon>
            {{ appointment_label || 'Book an appointment' }}
          </v-btn>
          <v-btn :style="stylef['button']" text @click="close">
            <v-icon left>mdi-refresh</v-icon>
            Generate another report
          </v-btn>
          <v-btn :style="stylef['button']" text @click="go_home">
            <v-icon left>mdi-check</v-icon>
            Done
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'app_dialog',
    props: [
      'show_dialog',
      'stylef',
      'brand_display_name',
      'website_url',
      'maximum_reports',
      'appointment_label',
      'appointment_booking_url',
    ],
    methods: {
      close() {
        this.$emit('ANOTHER_REPORT');
      },
      go_home() {
        this.$emit('ANOTHER_REPORT');
        if (this.website_url) window.location.href = this.website_url;
      },
    },
  };
</script>

<style scoped></style>
